import {IComponentController} from 'angular';
import {IMonoOccurrence, IMonoOccurrenceOptions} from '../../../../../core/services/mono-occurrence.service';
import {IFormulaire, IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IEcranDetailsResourcesEntite} from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';

interface IPageDO0039 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    monoOccurrence: IMonoOccurrence,
    monoOccurrenceOptions: IMonoOccurrenceOptions,
    formulairePro: IFormulaire;
    formulaireCon: IFormulaire;
    formulaireRea: IFormulaire;
    formulairePos: IFormulaire;
    formulaireOff: IFormulaire;
}

/* @ngInject */
export default function Do0039Controller(ecranDetails: IEcranDetailsResourcesEntite,
                                         Formulaire: IFormulaireClass,
                                         FormulaireItemDivider: IFormulaireItemDividerClass,
                                         FormulaireItem: IFormulaireItemClass) {
    const vm: IPageDO0039 = this;

        vm.monoOccurrenceOptions = {
            id: ecranDetails.valeurs.pcdcleint,
            fonctions: {
               boutonDupliquer: false
             },
            formulaire: new Formulaire('LBL_BLC_PCD', [
                new FormulaireItem('vaccanrejaff'),
                new FormulaireItem('vaccanrejald'),
                new FormulaireItem('pcdnbrjrsdis')
            ])
        };

        vm.formulairePro = new Formulaire('LBL_DIV_PRO', [
            new FormulaireItem('vactsmrai'),
            new FormulaireItem('ttccleinttsm') 
        ]);

        vm.formulaireRea = new Formulaire('LBL_DIV_REA', [
            new FormulaireItem('pcdflgaffdotaut'),
            new FormulaireItem('pcdflgaffdatdebdot') 
        ], {largeurDefaut: 100});

        vm.formulaireCon = new Formulaire('LBL_DIV_CON', [
            new FormulaireItem('vactsmraidmp'),
            new FormulaireItem('ttccleintdmp')
        ]);
        vm.formulairePos = new Formulaire('LBL_DIV_POS', [
            new FormulaireItem('pcdnbrjrsajtdatest')
        ]);  
}
